import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api/axios";

// Auth rides the axios interceptor. Blank filters are dropped: `direction=""`
// is a 400, and the rest would only narrow to nothing.
const clean = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null),
  );

// ErrorBanner only prints a useful heading with the backend's own message.
const fetchAdjustments = (filters) =>
  axiosInstance
    .get("/api/admin/wallets/adjustments", { params: clean(filters) })
    .then((r) => r.data.data)
    .catch((e) => {
      throw new Error(e?.response?.data?.message || e.message);
    });

export function useAdjustments(filters) {
  return useQuery({
    queryKey: ["wallet-adjustments", filters],
    queryFn: () => fetchAdjustments(filters),
    placeholderData: (prev) => prev,
    refetchOnWindowFocus: false,
  });
}

export const DIRECTIONS = [
  { value: "", label: "All" },
  { value: "credit", label: "Credit" },
  { value: "debit", label: "Debit" },
];

export const WALLET_OPTIONS = [
  { value: "", label: "All wallets" },
  { value: "GUSD", label: "GUSD" },
  { value: "BFM", label: "BFM" },
  { value: "APP_CREDIT", label: "APP_CREDIT" },
  { value: "FOREX", label: "FOREX" },
];
